
      import { createLanguage, createTranslationFile } from '@vocab/webpack/web';
      
    const translations = createTranslationFile({
      "en": createLanguage(
        require.resolveWeak("./translations.json-en-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJhcHBsaWNhdGlvbi11cmwtbGFiZWwiOiJBcHBsaWNhdGlvbiBVUkwifQ==!"),
        () => import(
          /* webpackChunkName: "en-translations" */
          "./translations.json-en-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJhcHBsaWNhdGlvbi11cmwtbGFiZWwiOiJBcHBsaWNhdGlvbiBVUkwifQ==!"
        )
      ),
"th": createLanguage(
        require.resolveWeak("./translations.json-th-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJhcHBsaWNhdGlvbi11cmwtbGFiZWwiOiJVUkwg4LmD4Lia4Liq4Lih4Lix4LiE4LijIn0=!"),
        () => import(
          /* webpackChunkName: "th-translations" */
          "./translations.json-th-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJhcHBsaWNhdGlvbi11cmwtbGFiZWwiOiJVUkwg4LmD4Lia4Liq4Lih4Lix4LiE4LijIn0=!"
        )
      ),
"id": createLanguage(
        require.resolveWeak("./translations.json-id-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJhcHBsaWNhdGlvbi11cmwtbGFiZWwiOiJMaW5rIExhbWFyYW4ifQ==!"),
        () => import(
          /* webpackChunkName: "id-translations" */
          "./translations.json-id-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJhcHBsaWNhdGlvbi11cmwtbGFiZWwiOiJMaW5rIExhbWFyYW4ifQ==!"
        )
      ),
"en-AU": createLanguage(
        require.resolveWeak("./translations.json-en-AU-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJhcHBsaWNhdGlvbi11cmwtbGFiZWwiOiJBcHBsaWNhdGlvbiBVUkwifQ==!"),
        () => import(
          /* webpackChunkName: "en-AU-translations" */
          "./translations.json-en-AU-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJhcHBsaWNhdGlvbi11cmwtbGFiZWwiOiJBcHBsaWNhdGlvbiBVUkwifQ==!"
        )
      ),
"en-HK": createLanguage(
        require.resolveWeak("./translations.json-en-HK-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJhcHBsaWNhdGlvbi11cmwtbGFiZWwiOiJBcHBsaWNhdGlvbiBVUkwifQ==!"),
        () => import(
          /* webpackChunkName: "en-HK-translations" */
          "./translations.json-en-HK-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJhcHBsaWNhdGlvbi11cmwtbGFiZWwiOiJBcHBsaWNhdGlvbiBVUkwifQ==!"
        )
      ),
"en-ID": createLanguage(
        require.resolveWeak("./translations.json-en-ID-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJhcHBsaWNhdGlvbi11cmwtbGFiZWwiOiJBcHBsaWNhdGlvbiBVUkwifQ==!"),
        () => import(
          /* webpackChunkName: "en-ID-translations" */
          "./translations.json-en-ID-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJhcHBsaWNhdGlvbi11cmwtbGFiZWwiOiJBcHBsaWNhdGlvbiBVUkwifQ==!"
        )
      ),
"en-MY": createLanguage(
        require.resolveWeak("./translations.json-en-MY-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJhcHBsaWNhdGlvbi11cmwtbGFiZWwiOiJBcHBsaWNhdGlvbiBVUkwifQ==!"),
        () => import(
          /* webpackChunkName: "en-MY-translations" */
          "./translations.json-en-MY-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJhcHBsaWNhdGlvbi11cmwtbGFiZWwiOiJBcHBsaWNhdGlvbiBVUkwifQ==!"
        )
      ),
"en-NZ": createLanguage(
        require.resolveWeak("./translations.json-en-NZ-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJhcHBsaWNhdGlvbi11cmwtbGFiZWwiOiJBcHBsaWNhdGlvbiBVUkwifQ==!"),
        () => import(
          /* webpackChunkName: "en-NZ-translations" */
          "./translations.json-en-NZ-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJhcHBsaWNhdGlvbi11cmwtbGFiZWwiOiJBcHBsaWNhdGlvbiBVUkwifQ==!"
        )
      ),
"en-PH": createLanguage(
        require.resolveWeak("./translations.json-en-PH-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJhcHBsaWNhdGlvbi11cmwtbGFiZWwiOiJBcHBsaWNhdGlvbiBVUkwifQ==!"),
        () => import(
          /* webpackChunkName: "en-PH-translations" */
          "./translations.json-en-PH-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJhcHBsaWNhdGlvbi11cmwtbGFiZWwiOiJBcHBsaWNhdGlvbiBVUkwifQ==!"
        )
      ),
"en-SG": createLanguage(
        require.resolveWeak("./translations.json-en-SG-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJhcHBsaWNhdGlvbi11cmwtbGFiZWwiOiJBcHBsaWNhdGlvbiBVUkwifQ==!"),
        () => import(
          /* webpackChunkName: "en-SG-translations" */
          "./translations.json-en-SG-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJhcHBsaWNhdGlvbi11cmwtbGFiZWwiOiJBcHBsaWNhdGlvbiBVUkwifQ==!"
        )
      ),
"en-TH": createLanguage(
        require.resolveWeak("./translations.json-en-TH-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJhcHBsaWNhdGlvbi11cmwtbGFiZWwiOiJBcHBsaWNhdGlvbiBVUkwifQ==!"),
        () => import(
          /* webpackChunkName: "en-TH-translations" */
          "./translations.json-en-TH-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJhcHBsaWNhdGlvbi11cmwtbGFiZWwiOiJBcHBsaWNhdGlvbiBVUkwifQ==!"
        )
      ),
"th-TH": createLanguage(
        require.resolveWeak("./translations.json-th-TH-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJhcHBsaWNhdGlvbi11cmwtbGFiZWwiOiJVUkwg4LmD4Lia4Liq4Lih4Lix4LiE4LijIn0=!"),
        () => import(
          /* webpackChunkName: "th-TH-translations" */
          "./translations.json-th-TH-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJhcHBsaWNhdGlvbi11cmwtbGFiZWwiOiJVUkwg4LmD4Lia4Liq4Lih4Lix4LiE4LijIn0=!"
        )
      ),
"id-ID": createLanguage(
        require.resolveWeak("./translations.json-id-ID-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJhcHBsaWNhdGlvbi11cmwtbGFiZWwiOiJMaW5rIExhbWFyYW4ifQ==!"),
        () => import(
          /* webpackChunkName: "id-ID-translations" */
          "./translations.json-id-ID-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJhcHBsaWNhdGlvbi11cmwtbGFiZWwiOiJMaW5rIExhbWFyYW4ifQ==!"
        )
      ),
"en-PSEUDO": createLanguage(
        require.resolveWeak("./translations.json-en-PSEUDO-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJhcHBsaWNhdGlvbi11cmwtbGFiZWwiOiJb4bqsxqXGpcaaw6zDrMOsw6fEg8SDxIPhua/DrMOsw6zDtsO2w7bguIHguLXguYkgx5nFmMWBXSJ9!"),
        () => import(
          /* webpackChunkName: "en-PSEUDO-translations" */
          "./translations.json-en-PSEUDO-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJhcHBsaWNhdGlvbi11cmwtbGFiZWwiOiJb4bqsxqXGpcaaw6zDrMOsw6fEg8SDxIPhua/DrMOsw6zDtsO2w7bguIHguLXguYkgx5nFmMWBXSJ9!"
        )
      )
      });
  
      export { translations as default };
    